import { z } from 'zod'

export const SaleStatus = z.enum([
    'unpaid',
    'pending',
    'channel_pending',
    'erp_pending',
    'in_fulfillment',
    'completed',
    'insufficient_stock',
    'waiting_for_stock',
    'to_return',
    'returned',
    'part_returned',
    'in_cancel',
    'canceled',
    'part_canceled',
    'failed',
    'insufficient_stock_pending',
])
export type SaleStatus = z.infer<typeof SaleStatus>

export const SaleEvent = z.object({
    id: z.number(),
    sale: z.number(),
    status: SaleStatus,
    channel_status: z.string().nullable(),
    date: z.string(),
})
export type SaleEvent = z.infer<typeof SaleEvent>

export const SaleNote = z.object({
    id: z.number(),
    sale: z.number(),
    text: z.string().nullable(),
    date_created: z.string(),
    images: z.array(z.object({ id: z.number().nullable(), image: z.string().nullable() })),
})
export type SaleNote = z.infer<typeof SaleNote>
